module.exports = __webpack_public_path__ + "static/banner_myinfo@2x-74154ebf3847affe4cee63844a829dd9.png";